import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { Page$reflection as Page$reflection_1 } from "../FileImport/Model.js";
import { union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Import", "FileImport", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.Imports.Model.Page", [], Page, () => [[], [["Item", Page$reflection_1()]], []]);
}

